import { createContext, useContext } from 'react';
import type { ColumnElementType, Table } from '../types';

export interface TablesContextType {
  elements: ColumnElementType[];
  tables: Table[];
  hasBarHighlight: boolean;
  setActiveTable: (id: string) => void;
  activeTable?: Table;
}

// @ts-expect-error Хук используется только внутри контекста, дефолты не нужны
export const TablesContext = createContext<TablesContextType>({});

export const useTables = () => {
  return useContext(TablesContext);
};
